import { render, staticRenderFns } from "./back-drop.vue?vue&type=template&id=146dbc2d&scoped=true"
import script from "./back-drop.vue?vue&type=script&setup=true&lang=ts"
export * from "./back-drop.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./back-drop.vue?vue&type=style&index=0&id=146dbc2d&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146dbc2d",
  null
  
)

export default component.exports